var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTickDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3011 0.209053L13.8 0.695828L8.40047 8.1001L6.21171 5.93844L7.13862 4.66654L8.40047 5.40248L13.3011 0.209053ZM8.9193 0.100098L9.41827 0.586872L4.01869 7.99114L0.300049 4.33368L1.13038 3.52364L4.01869 5.29353L8.9193 0.100098Z",
    fill: "#7e8e98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTickDark);
export default __webpack_public_path__ + "static/media/double_tick_dark.5fd8bc41.svg";
export { ForwardRef as ReactComponent };